<template>
  <div class="DetailGrid__nav realisation-header">
    <StepsNavSimple
      :step="step"
      :steps="steps"
      :record="record"
      class="DetailGrid__nav mb-3"
    />
    <b-navbar
      id="rp-header"
      class="mt-3"
      type="dark"
      variant="dark"
    >
      <OverlayPanel
        ref="op"
        append-to="rp-header"
      >
        {{ $t('RealisationHeader.sentence1') }}
      </OverlayPanel>
      <b-navbar-brand
        variant="light"
        :class="titleSize"
      >
        {{ (step + '').replace('-', ' ') }}. {{ $t(`${currentStepLabel}`) }} ({{ $t('new').toLocaleLowerCase() }} {{ $t(`processes.sidebar.process_types.${processType}`) }})
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <slot />
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import StepsNavSimple from '@/components/realisation/StepsNavSimple.vue';
import OverlayPanel from 'primevue/overlaypanel';

import { mapGetters } from 'vuex';

export default {
  name: 'RealisationHeader',
  components: { StepsNavSimple, OverlayPanel },
  props: {
    step: {
      type: [String, Number],
      default: '1'
    },
    feedback: {
      type: String,
      default: null
    },
    feedbackMessage: {
      type: String,
      default: ''
    },
    record: {
      type: Object,
      required: false,
      default: () => {}
    },
    titleSize: {
      type: String,
      default: ''
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('tenant', ['getSteps', 'getActiveProcessTypes']),
    ...mapGetters('processes', ['getCurrentProcessType']),

    steps () {
      return this.getSteps
    },
    processType () {
      return this.getCurrentProcessType || this.$route.name.split('-').pop() || this.$route.params.uuid.split('-').pop() || 'realisation'
    },
    currentStep() {
      return this.steps?.find(step => (step.step || Number(step.short)) === this.step) || {};
    },
    currentStepLabel() {
      return this.currentStep.label
        ? (this.currentStep.label[this.processType] || this.currentStep.label[[this.$i18n.locale]] || this.currentStep.label)
        : '';
    }
  },
  // watch: {
  //   getSteps: {
  //     immediate: true,
  //     handler (steps) {
  //       console.log('getSteps watcher', steps, this.processType)
  //     }
  //   }
  // },
  methods: {
    handleOpen(event) {
      this.$refs.op.toggle(event);
    }
  }
};
</script>

<style lang="scss">
.navbar-brand {
  &.sm {
    font-size: 1.1rem;
  }
}
.header-info {
  background: rgba(0, 0, 0, 0.05);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
}
.compactsteps {
  padding-top: 4px !important;
  padding-bottom: 4px !important;

  .navbar-brand {
    font-size: 1rem !important;
    padding: 0;
  }
}
.DetailGrid__nav {
  &.realisation-header {
    position: sticky;
    top: $menu-height;
    background: white;
    z-index: 9;
    .p-overlaypanel {
      min-width: 100% !important;
      max-height: none;
      top: 100% !important;
      left: 0 !important;
    }
  }
  .bi-exclamation-circle-fill {
    color: #ced4da;
    cursor: pointer;
  }
  .navbar-nav {
    display: flex;
    align-items: center;
    gap: 0.7em;
    .btn {
      &.previous {
        order: 1;
      }
    }
    .btn:last-child,
    #next {
      order: 2;
    }
  }
}
</style>
